import React, { SyntheticEvent, useCallback, useContext } from "react";
import styles from './previewLayer.module.scss';
import { checkConfigurationTypeRotationAvailable } from "@susu/custom-made/utils/utils";
import cn from 'classnames';
import { ConfigurationTypes } from "@susu/custom-made/utils/productDefinition";
import { LayerDefinition } from "@susu/custom-made/utils/preview/layers";
import PreviewRotationLayer from "./previewRotationLayer";
import { ThemeContext } from "@susu/custom-made/providers";

const PreviewFirstLayer = React.memo(({
  layers,
  fallbackImage,
  isPreviewFailed,
  setIsPreviewFailed,
  configurationType,
}: Readonly<{
  layers: LayerDefinition[];
  fallbackImage: LayerDefinition;
  isPreviewFailed: boolean;
  setIsPreviewFailed: React.Dispatch<React.SetStateAction<boolean>>
  configurationType?: ConfigurationTypes;
}>) => {
  const { state } = useContext(ThemeContext);
  
  const onBaseLayerFailed = useCallback(
    (e: SyntheticEvent<HTMLImageElement, Event>) => {
      if (!isPreviewFailed) {
        setIsPreviewFailed(true);
        e.currentTarget.src = fallbackImage.src;
        e.currentTarget.srcset = fallbackImage.srcset;
        e.currentTarget.setAttribute('fallback', fallbackImage.src);
      }
    },
    [fallbackImage, isPreviewFailed],
  );

  const onBaseLayerLoaded = useCallback(
    (e: SyntheticEvent<HTMLImageElement, Event>) => {
      if (e.currentTarget.getAttribute('fallback') === e.currentTarget.src) return;

      setIsPreviewFailed(false);
    },
    [fallbackImage, isPreviewFailed],
  );

  return (
    <>
      {checkConfigurationTypeRotationAvailable(configurationType, state.growthbookFeatures['show-3D-preview-image']) && (
        <PreviewRotationLayer
          layer={layers[0]}
          index={0}
          keyPrefix="baselayer"
          onLayerFailed={onBaseLayerFailed}
          onLayerLoaded={onBaseLayerLoaded}
        />
      )}
      {!checkConfigurationTypeRotationAvailable(configurationType, state.growthbookFeatures['show-3D-preview-image']) && (
        <div className={cn(styles.layer, styles.isActive)}>
          <img
            src={layers[0].src}
            srcSet={layers[0].srcset}
            onError={onBaseLayerFailed}
            onLoad={onBaseLayerLoaded}
            alt="baselayer"
            sizes={layers[0].sizes}
            fetchPriority="high"
            loading="eager"
          />
        </div>
      )}
    </>
  );
});

export default PreviewFirstLayer;